export const pessoas = [2,4,5,6,8]